module.exports = __webpack_public_path__ + "static/img/guide.74bfce6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide.png
// module id = vG7k
// module chunks = 73